import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SideMenuItem } from 'src/app/shared/interfaces';
import { IconSvgComponent } from 'src/app/shared/component/icon/svg-icon.component';

@Component({
  selector: 'app-side-nav-item',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, IconSvgComponent],
  templateUrl: './side-nav-item.component.html',
  styleUrls: ['./side-nav-item.component.scss'],
})
export class SideNavItemComponent implements OnInit {
  @Input() menu: SideMenuItem;
  @Input() isSideNavCollapsed: boolean;
  constructor() {}

  ngOnInit(): void {}
}
